export default "__VITE_ASSET__DLU1P8lf__"